import { useAtomValue } from 'jotai';
import { useTranslation } from '@wojtekmaj/react-t';
import Markdown from 'markdown-to-jsx';

import {
  Body,
  HeaderContentWrapper,
  HeaderWrapper,
  LogoWrapper,
  MessageDate,
  Picture,
  Sender,
  Subject,
} from './message_content.styles';

import Logo from '../../../../common/logo';

import { formatRelative } from '../../../../../utils/date';

import { businessQuery, vendorMessageQuery } from '../../../../../store';

import type { Message } from '@rewardopl/types';

type MessageContentProps = {
  messageId: Message['_id'];
};

export default function MessageContent({ messageId }: MessageContentProps) {
  const message = useAtomValue(vendorMessageQuery(messageId));

  const { business_id: businessId } = message;

  const business = useAtomValue(businessQuery(businessId));

  const pictureString = useTranslation('Picture');

  return (
    <>
      <HeaderWrapper>
        <LogoWrapper>
          <Logo borderWidth={0} business={business} size={64} />
        </LogoWrapper>
        <HeaderContentWrapper>
          <MessageDate>{formatRelative(message.created_at)}</MessageDate>
          <Subject>{message.subject}</Subject>
          <Sender>{business.name}</Sender>
        </HeaderContentWrapper>
      </HeaderWrapper>
      <Body>
        <Markdown>{message.body}</Markdown>
      </Body>
      {message.attachment ? (
        <Picture alt={pictureString} src={`/api/uploads/${message.attachment}`} />
      ) : null}
    </>
  );
}
